var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileWithErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_407_3401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1762 6.01607L15.4119 0.251786C15.2512 0.0910715 15.0342 0 14.8065 0H3.42794C2.95384 0 2.5708 0.383036 2.5708 0.857143V23.1429C2.5708 23.617 2.95384 24 3.42794 24H20.5708C21.0449 24 21.4279 23.617 21.4279 23.1429V6.62411C21.4279 6.39643 21.3369 6.17679 21.1762 6.01607ZM19.4512 7.01786H14.4101V1.97679L19.4512 7.01786ZM19.4994 22.0714H4.49937V1.92857H12.5887V7.71429C12.5887 8.01265 12.7072 8.2988 12.9182 8.50978C13.1291 8.72076 13.4153 8.83929 13.7137 8.83929H19.4994V22.0714ZM10.9279 18.2143C10.9279 18.4984 11.0408 18.771 11.2418 18.9719C11.4427 19.1728 11.7152 19.2857 11.9994 19.2857C12.2835 19.2857 12.5561 19.1728 12.757 18.9719C12.9579 18.771 13.0708 18.4984 13.0708 18.2143C13.0708 17.9301 12.9579 17.6576 12.757 17.4567C12.5561 17.2557 12.2835 17.1429 11.9994 17.1429C11.7152 17.1429 11.4427 17.2557 11.2418 17.4567C11.0408 17.6576 10.9279 17.9301 10.9279 18.2143ZM11.3565 15.4286H12.6422C12.7601 15.4286 12.8565 15.3321 12.8565 15.2143V10.2857C12.8565 10.1679 12.7601 10.0714 12.6422 10.0714H11.3565C11.2387 10.0714 11.1422 10.1679 11.1422 10.2857V15.2143C11.1422 15.3321 11.2387 15.4286 11.3565 15.4286Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_407_3401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileWithErrorIcon);
export default __webpack_public_path__ + "static/media/file-with-error-icon.f0d14a3bcee522915bd041c20a8bdf2a.svg";
export { ForwardRef as ReactComponent };